import "core-js/stable";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import '@gaf/typescript-authentication-okta/polyfill'
import Routes from "./routes";
import { store } from "./store";
import { storeCustomerID } from "./utils/utils";
import "./AppTracking/appInsight";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "../assets/sass/components/global.scss";

storeCustomerID();

ReactDOM.render(
    <Provider store={store}>
        <Routes />
    </Provider>,
    document.getElementById("react-app")
);

export { store };
